<template>
  <div style="padding-bottom: 60px">
    <div style="display:flex;justify-content: space-between">
      <el-table
          :data="item.virtualList"
          height="250"
          border
          style="width: 100%">

        <el-table-column
            type="index"
            label=""
            width="50"
            align="center"
        ></el-table-column>
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>

        <el-table-column
            prop="cardName"
            label="卡型"
            width="110" show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column
            prop="beforeUse"
            label="扣减前"
            width="80">
        </el-table-column>

        <el-table-column
            prop="courseTime"
            label="上课时间"
            width="100">
        </el-table-column>

        <el-table-column
            prop="name"
            label="学生名字"
            width="90">
        </el-table-column>

        <el-table-column
            label="被扣减卡"
            width="90">

          <template #default="scope">
            <label v-if="scope.row.cardType==1">主卡</label>
            <label v-if="scope.row.cardType==2">赠卡</label>
            <label v-if="scope.row.cardType==3">298主卡</label>
            <label v-if="scope.row.cardType==4">298赠卡</label>
          </template>
        </el-table-column>


        <el-table-column
            prop="reduceCourseNumber"
            label="扣减课时"
            width="90">
        </el-table-column>
        <el-table-column
            prop="reduceRate"
            label="扣减比例"
            width="90">
        </el-table-column>


      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: "VirtualCourseDetail",
  props: {
    item: Array,
  },
  data() {
    return {
      tableData: [{
        date: '2016-05-02',
        name: '王小虎'
      }]
    }
  },
  methods: {}, created() {
    console.log('子组件打开',this.item);

  },
}
</script>

<style scoped>
.padding-top {
  padding-top: 10px;
}

.card {
  display: flex;
  justify-content: space-around;
  border-bottom: solid 1px #e4e7ed;
  margin-bottom: 8px;
}

.mainCardName {
  font-size: 16px;
  font-weight: bold;
  background: linear-gradient(to right, #bb9c6e, #000000);
  font-style: italic;
  -webkit-background-clip: text;
  background-clip: inherit;
  color: transparent;
  padding: 10px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.viceCardName {
  font-size: 16px;
  font-weight: bold;
  background: linear-gradient(to right, #81B7EB, #000000);
  font-style: italic;
  -webkit-background-clip: text;
  background-clip: inherit;
  color: transparent;
  padding: 10px 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type {
  line-height: 26px;
  font-style: italic;
  border-radius: 0px 15px 0px 15px;
  font-weight: bold;
  height: 26px;
  width: 66px;
  font-size: 12px;
  text-align: center;
  float: right;
}

.main {
  background: -webkit-linear-gradient(left, #F5DCB5, #e3c28f);
  height: 150px;
  border-radius: 15px;
  width: 260px
}

.vice {
  background: -webkit-linear-gradient(left, #C9E3F8, #81B7EB);
  height: 150px;
  border-radius: 15px;
  margin-left: 20px;
  width: 260px
}
</style>
